import {Component, ViewChild} from '@angular/core';

import {Destroyable} from '../../../destroyable.component';
import {EmployeeSelectComponent} from '../../employee-select/employee-select.component';
import {ModalComponent} from '../../modal';

@Component({
  selector: 'gp-reassign-request-popup',
  templateUrl: './reassign-request-popup.component.html',
  styleUrls: ['./reassign-request-popup.component.scss']
})
export class ReassignRequestPopupComponent extends Destroyable {
  public reassigning = false;

  public reassign: (modalRef: ModalComponent, selectedUser: number) => any;

  public selectedUser: number = null;

  @ViewChild(EmployeeSelectComponent)
  public employeeSelect: EmployeeSelectComponent;

  public reassignRequest(modalRef: ModalComponent) {
    if (this.selectedUser !== null) {
      this.reassign(modalRef, this.selectedUser);
    }
  }

  public selectUser(userId: number | number[]): void {
    this.selectedUser = Array.isArray(userId) ? userId[0] ?? null : userId;
  }

  public reset() {
    this.selectedUser = null;
    this.employeeSelect?.reset();
  }

}
